import { useContext } from 'react';

import DataProviderContext from 'app/context/DataProviderContext';

export default () => useContext(DataProviderContext);
